/**
 * Configuration file for API keys and content sources
 *
 * SETUP INSTRUCTIONS:
 * 1. Create a .env file in the root directory
 * 2. Add your API keys:
 *    VITE_YOUTUBE_API_KEY=your_youtube_api_key
 *    VITE_INSTAGRAM_ACCESS_TOKEN=your_instagram_token
 * 3. Never commit .env to version control
 */

export const config = {
  // API Keys (use environment variables in production)
  youtube: {
    apiKey: import.meta.env.VITE_YOUTUBE_API_KEY || '',
    channelId: 'UCpdZjhyJ8r32P5rtDEYrBBA',
    maxResults: 10,
  },

  instagram: {
    accessToken: import.meta.env.VITE_INSTAGRAM_ACCESS_TOKEN || '',
    username: 'newoonewoo',
    userId: '', // Will be fetched dynamically
    maxResults: 100,
    maxPages: 5, // Maximum number of pages to fetch via pagination
  },

  tiktok: {
    username: 'newoonewoo',
    // TikTok currently requires manual embed URLs or official API access
    // For now, we'll support manual configuration
  },

  // Content classification hashtags
  hashtags: {
    gym: ['#thegym', '#gym', '#workout', '#fitness'],
    office: ['#theoffice', '#office', '#work', '#productivity'],
    closet: ['#ootd', '#outfit', '#fashion', '#style'],
  },

  // Section limits (FIFO replacement when exceeded)
  limits: {
    hero: 1,
    gym: 12,
    office: 12,
    closet: 15,
  },

  // Cache settings (in milliseconds)
  cache: {
    youtube: 10 * 60 * 1000, // 10 minutes
    instagram: 15 * 60 * 1000, // 15 minutes
    tiktok: 30 * 60 * 1000, // 30 minutes
  },

  // Social media URLs
  social: {
    youtube: `https://www.youtube.com/channel/UCpdZjhyJ8r32P5rtDEYrBBA`,
    instagram: `https://www.instagram.com/newoonewoo/`,
    tiktok: `https://www.tiktok.com/@newoonewoo`,
  },
};

export default config;
